// Theme colors based on logo
export const themeColors = {
  primary: {
    main: '#FF6B35', // Orange from logo
    light: '#FF8C5A',
    dark: '#E55A2B',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#2C3E50', // Dark blue/gray
    light: '#34495E',
    dark: '#1A252F',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F8F9FA',
    paper: '#FFFFFF',
    sidebar: '#2C3E50',
    hover: 'rgba(255, 107, 53, 0.08)',
  },
  text: {
    primary: '#2C3E50',
    secondary: '#6C757D',
    light: '#ADB5BD',
    white: '#FFFFFF',
  },
  border: {
    light: '#E9ECEF',
    main: '#DEE2E6',
  },
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',
};
